<template>
    <div>
        <card-header title="#Social" :subheader="trip.title" icon="fa-hashtag"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Navigator Settings" icon="fa-sliders-h"/>
                <container-list-item padded>
                    <b-field>
                        <b-switch v-model="experienceEnabled" @input="saveFlags">
                            #Social tab enabled for this trip
                        </b-switch>
                    </b-field>
                    <b-field>
                        <b-switch v-model="wallStaffOnly" @input="saveFlags" :disabled="!experienceEnabled">
                            Trip Wall: staff-only posting
                        </b-switch>
                    </b-field>
                    <p class="has-text-grey is-size-7 mt-2">
                        When the tab is off, travellers see "not available for this trip".
                        The wall lock still lets participants react and comment — they just can't create posts.
                    </p>
                </container-list-item>

                <separator-list-item/>

                <navigation-list-item
                    icon="fa-bullhorn"
                    title="Announcements &amp; Polls"
                    :active="child && child.definition.component === 'trip-announcements'"
                    @click="$openCard('trip-announcements', {tripId: props.tripId}, card)"
                />
                <navigation-list-item
                    icon="fa-images"
                    title="Trip Wall (Moderation)"
                    :active="child && child.definition.component === 'trip-wall'"
                    @click="$openCard('trip-wall', {tripId: props.tripId}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";

    import {client as http} from '@/http_client';

    export default {
        name: "TripExperience",
        props: ['card', 'child', 'props'],
        components: {NavigationListItem, ContainerListItem, SeparatorListItem, SubheaderListItem, CardList, CardBody, CardHeader},
        data: function() {
            return {
                trip: {},
                experienceEnabled: false,
                wallStaffOnly: false
            };
        },
        methods: {
            loadTrip: function(force) {
                this.$emit('loading', true);
                http.get('/api/trips/' + this.props.tripId, {force}).then(response => {
                    this.trip = response.data;
                    this.experienceEnabled = response.data.app_experience === 1;
                    this.wallStaffOnly = response.data.app_wall_staff_only === 1;
                    this.$emit('loading', false);
                });
            },
            // The trips PUT picks these up via sqlBody — no dedicated endpoint.
            // The endpoint expects the trip object back: title/location/
            // start_on/end_on are required, and `id` must be in the body too
            // (the WHERE binds from it). Dates are DATE columns and arrive as
            // plain strings — safe to echo unchanged.
            saveFlags: function() {
                http.put('/api/trips/' + this.props.tripId, {
                    id: this.trip.id,
                    title: this.trip.title,
                    location: this.trip.location,
                    start_on: this.trip.start_on,
                    end_on: this.trip.end_on,
                    app_experience: this.experienceEnabled ? 1 : 0,
                    app_wall_staff_only: this.wallStaffOnly ? 1 : 0
                }, {force: true}).then(() => {
                    this.$reloadCard('trip', {tripId: this.props.tripId});
                    this.$reloadCard('edit-trip', {tripId: this.props.tripId});
                });
            }
        },
        mounted() {
            this.loadTrip();
        }
    };
</script>
